import Vue from 'vue'
import Router from 'vue-router'

import HomePage from '@/views/HomePage'
import MainApp from '@/views/MainApp'

import DummyView from '@/views/DummyView'
import LoginPage from '@/views/LoginPage'
import PageNotFound from '@/views/PageNotFound'
import Forbidden from '@/views/Forbidden'

// const axios = require('axios').default
const cookie = require('cookie')

Vue.use(Router)

const router = new Router({
	routes: [
		// specific path put first so it can resolve
		{
			/* root path */
			path: '/',
			component: MainApp,
			meta: {
				breadcrumb: '🏠Home',
				authRequired: true
			},
			children: [
				{ /* /home */
					path: '',
					name: 'HomePage',
					component: HomePage,
					meta: {
						title: 'Home Page'
					}
				},

				// statistik
				{
					path: 'statistik',
					component: () => import('../views/StatistikPage'),
					meta: {
						breadcrumb: '📊Statistik Temuan',
						title: 'Statistik Temuan'
					}
				},

				// log
				{
					path: 'log-aktifitas',
					component: () => import('../views/LogAktifitasPage'),
					meta: {
						breadcrumb: '👀Log Aktifitas',
						title: 'Log Aktifitas'
					}
				},

				// browse temuan?
				{
					path: 'temuan',
					component: DummyView,
					meta: {
						breadcrumb: '🔍Browse Temuan'
					},
					children: [
						// real browse
						{
							path: '',
							name: 'BrowseTemuan',
							component: () => import('../views/BrowseTemuan'),
							meta: {
								title: 'Browse Temuan',
							}
						},
						// input temuan baru
						{
							path: 'new',
							name: 'InputTemuan',
							component: () => import('../views/InputTemuanPage'),
							meta: {
								title: 'Input Temuan Baru',
								breadcrumb: '✏️Input Temuan Baru'
							}
						},
						// edit temuan
						{
							path: 'edit',
							name: 'EditTemuan',
							component: () => import('../views/EditTemuanPage'),
							meta: {
								title: 'Edit Temuan',
								breadcrumb: '✏️Edit Temuan'
							}
						}
					]
				},

				// browse tinjut
				{
					path: 'tinjut',
					name: 'BrowseTinjut',
					meta: {
						title: 'Browse Tinjut',
						breadcrumb: '🔍(Browse/Rekam) Tinjut'
					},
					component: () => import('../views/BrowseTindakLanjut')
				},

				// browse toko
				{
					path: 'toko',
					name: 'BrowseToko',
					component: () => import('../views/BrowseToko'),
					meta: {
						title: 'Browse Toko',
						breadcrumb: '🏪Browse Toko'
					}
				},

				/* /test */
				// test page for playing
				{
					path: '/test',
					name: 'TestPage',
					component: () => import('../views/TestPage.vue'),
					meta: {
						title: 'Test Page',
						breadcrumb: '🔧TestPage'
					}
				},
			]
		},


		// login
		{
			path: '/login',
			name: 'Login',
			component: LoginPage
		},
		// when user has no roles in this app
		{
			path: '/forbidden',
			name: 'Forbidden',
			component: Forbidden
		},
		// catch all when all else fails
		{
			path: '*',
			name: 'PageNotFound',
			component: PageNotFound
		}
	],

	//  mode: 'history'
})

import { fakeAuth, realAuth } from './authHandler'
import store from '../store'

// set navigation guards here
router.beforeEach(async (to, from, next) => {
	console.log('-->>')
	console.log(to)

	// bypass authentication if we're in dev mode
	// also, set default userInfo
	if (process.env.NODE_ENV != 'production') {
		fakeAuth(from, to, next)
	} else {
		realAuth(from, to, next)
	}
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js